import { render, staticRenderFns } from "./OpportunisticInfectiousBacteria.vue?vue&type=template&id=0ec0131a&scoped=true&"
import script from "./OpportunisticInfectiousBacteria.vue?vue&type=script&lang=js&"
export * from "./OpportunisticInfectiousBacteria.vue?vue&type=script&lang=js&"
import style0 from "./OpportunisticInfectiousBacteria.vue?vue&type=style&index=0&id=0ec0131a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec0131a",
  null
  
)

export default component.exports